// Kick-created Express accounts can be logo/color-branded on Stripe's side
// (Checkout, receipts, invoices). Stripe's own Dashboard branding page labels
// `primary_color` / `secondary_color` as "Brand color" / "Accent color" — the
// stripe-express contract mirrors that naming so it reads the same as what an
// admin would see if they opened the account directly on Stripe.
export const STRIPE_EXPRESS_LOGO_MIME_TYPES = [
    "image/png",
    "image/jpeg",
] as const;

export type StripeExpressLogoMimeType =
    (typeof STRIPE_EXPRESS_LOGO_MIME_TYPES)[number];

// Stripe's branding logo: JPG or PNG, at most 512KB, at least 128×128.
// Colors below are what Stripe shows when an Express account has no brand or
// accent color saved.
export const MAX_STRIPE_EXPRESS_LOGO_FILE_SIZE_BYTES = 512 * 1024;
export const MIN_STRIPE_EXPRESS_LOGO_DIMENSION_PX = 128;
export const STRIPE_EXPRESS_DEFAULT_BRAND_COLOR = "#525f7f";
export const STRIPE_EXPRESS_DEFAULT_ACCENT_COLOR = "#0074d4";

// Base64 inflates bytes by ~4/3, so this bounds the encoded string a client may
// send. Enforced at the schema so an oversized upload is rejected during
// validation, before the server allocates and decodes the whole buffer (the
// byte-length check on the decoded buffer stays as the exact ceiling).
export const MAX_STRIPE_EXPRESS_LOGO_BASE64_LENGTH =
    Math.ceil(MAX_STRIPE_EXPRESS_LOGO_FILE_SIZE_BYTES / 3) * 4;
